module.exports = __webpack_public_path__ + "static/media/beechwoodstory_logo.a065751b.jpg";